(function () {
    'use strict';

    angular.module("imApp").factory("stockZoneMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockZoneMenu: function (parms) {
                return $ihttp.post({
                    method: 930,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
